import { Card } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import AuthService from 'services/auth.service';
import FormResultMessage from './FormResultMessage';

interface UpdateUserFormProps {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
}

const UpdateUserForm: React.FC<UpdateUserFormProps> = ({
  id,
  firstname,
  lastname,
  email
}) => {
  const [message, setMessage] = useState<string | null>(null);
  const [messageType, setMessageType] = useState<
    'successupdate' | 'errorupdate'
  >('successupdate');
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  //To check information registered
  const formik = useFormik({
    initialValues: {
      name: firstname,
      lastname: lastname,
      email: email
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .min(3, 'First name must be at least 3 characters')
        .required('First name is required'),
      lastname: Yup.string()
        .min(3, 'Last name must be at least 3 characters')
        .required('Last name is required'),
      email: Yup.string()
        .email('Invalid email address')
        .required('Email is required')
    }),
    onSubmit: async values => {
      try {
        await AuthService.updateprofile({
          id: id,
          name: values.name,
          lastname: values.lastname,
          email: values.email
        });
        setMessage(
          'Information has been updated! Please sign out and sign in.'
        );
        setMessageType('successupdate');
      } catch (error) {
        setMessage('I apologize, but it seems there was a hiccup! ' + error);
        setMessageType('errorupdate');
      }
      setModalVisible(true);
    }
  });

  const closeModal = () => {
    setModalVisible(false);
  };

  return (
    <Card className="p-4 pt-2 bg-body-highlight">
      <form className="mb-0 pb-0" onSubmit={formik.handleSubmit}>
        <div>
          <label className="form-label">First name</label>
          <input
            type="text"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="form-control fs-8"
            title="First namme"
            aria-label="First namme"
          />
          {formik.touched.name && formik.errors.name ? (
            <div className="alert phoenix-primary text-primary p-0 fs-9 text-end">
              {formik.errors.name}
            </div>
          ) : null}
        </div>
        <div>
          <label className="form-label">Last name</label>
          <input
            type="text"
            name="lastname"
            value={formik.values.lastname}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="form-control fs-8"
            title="Last name"
            aria-label="Last name"
          />
          {formik.touched.lastname && formik.errors.lastname ? (
            <div className="alert phoenix-primary text-primary p-0 fs-9 text-end">
              {formik.errors.lastname}
            </div>
          ) : null}
        </div>
        <div>
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="form-control fs-8"
            title="Email address"
            aria-label="Email address"
          />
          {formik.touched.email && formik.errors.email ? (
            <div className="alert phoenix-primary text-primary p-0 fs-9 text-end">
              {formik.errors.email}
            </div>
          ) : null}
        </div>
        <div className=" pt-4">
          <button type="submit" className="btn btn-primary btn-block">
            <FeatherIcon icon="user-check" className="me-2" size={18} />
            Update Personal Information
          </button>
        </div>
      </form>
      <FormResultMessage
        show={modalVisible}
        message={message}
        messageType={messageType}
        logout={false}
        onClose={closeModal}
      />
    </Card>
  );
};

export default UpdateUserForm;
